import './ExternalAccLoginSuccess.scss';
// import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useEffect } from "react";
import { useNotifications } from "../../providers/Notifications";

export default function ExternalAccLoginSuccess() {
  // const { t } = useTranslation();
  const notificationsContext = useNotifications();

  useEffect(() => {
    if(window.location.href && window.location.href.includes('?code=')){
      let outlookAuthCodeValidator = window.location.href.split('=')[1].toString();
      if(outlookAuthCodeValidator && !outlookAuthCodeValidator.includes('server_error')){
          let outlookAuthCode: string = '';
          if(outlookAuthCodeValidator[outlookAuthCodeValidator.length - 1] === '#' || outlookAuthCodeValidator.indexOf('#') !== -1){
              outlookAuthCode = outlookAuthCodeValidator.slice(0,outlookAuthCodeValidator.indexOf('#'));
          }
          else {
              outlookAuthCode = outlookAuthCodeValidator;
          }
          notificationsContext.outlookAuthCodeChannel.postMessage(outlookAuthCode);
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="ext_acc_login_success--container">
      <div className="ext_acc_login_success--msg-container">
        <i className="icon-Confirmation-circle ext_acc_login_success--icon"></i>
        <p className="ext_acc_login_success--header"> Outlook Authentication Successful </p>
        <p className="ext_acc_login_success--text1"> This tab is redundant and no further actions can be taken.</p>
        <p className="ext_acc_login_success--text2"> Please feel free to close it.</p>
        <Button variant="outlined" className="ext_acc_login_success--button" onClick={()=>window.close()}>Close</Button>
      </div>
    </div>
  );
}
